import { computed } from 'vue';
import { useIdle, useTimestamp } from '@vueuse/core';
import { timeoutConfig } from '@/config/timeout.config';

export function useIdleTimeout() {
  const idleThresholdMs = timeoutConfig.idleThresholdMs;
  const { idle, lastActive, reset } = useIdle(idleThresholdMs);
  const now = useTimestamp({ interval: 100 });

  const idledFor = computed(() => {
    const active = Math.floor((now.value - lastActive.value) / 1000);
    return active > 0 ? active : 0;
  });

  const timeRemaining = computed(() => {
    const idleTimeInWarningPeriod = Math.max(
      0, 
      idledFor.value - (timeoutConfig.timeoutSeconds - timeoutConfig.warningSeconds)
    );
    return Math.max(0, timeoutConfig.warningSeconds - idleTimeInWarningPeriod);
  });

const timePercentage = computed(() => {
  const percentage = (timeRemaining.value * 1000 / timeoutConfig.warningMs) * 100;
  return Math.max(0, Math.min(100, Math.round(percentage)));
});
  const isTimedOut = computed(() => {
    return idledFor.value > timeoutConfig.timeoutSeconds;
  });

  const timeoutMessage = computed(() => {
    const timeoutDifferenceMs = timeoutConfig.timeoutMs - timeoutConfig.warningMs;
    
    if (timeoutDifferenceMs > 60000) {
      const minutes = Math.round(timeoutDifferenceMs / 60000);
      return `You have been idle for ${minutes} minute${minutes === 1 ? '' : 's'} and will be logged out in ${timeRemaining.value} seconds if there is no activity.`;
    } else {
      const seconds = Math.max(0, Math.floor(timeoutDifferenceMs / 1000));
      return `You have been idle for ${seconds} second${seconds === 1 ? '' : 's'} and will be logged out in ${timeRemaining.value} seconds if there is no activity.`;
    }
  });

  const extendSession = () => {
    reset();
  };

  return {
    idle,
    idledFor,
    timeRemaining,
    timePercentage,
    isTimedOut,
    timeoutMessage,
    extendSession
  };
}